import React from 'react'
import Grid from '@mui/material/Grid'
import PropTypes from 'prop-types'
import Cell from './Cell'
import { styled } from '@mui/material/styles'

export const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  margin: 'auto',
  width: 270,
  justifyContent: 'space-around',
}))

export default function FilterGrid({
  statusDriversFilter,
  dateLivraisonFilter,
  prestationFilter,
  setFilters,
  filtersValues,
}) {
  const filterArray = [prestationFilter, dateLivraisonFilter, statusDriversFilter]
  const onChangeFilter = (filterValuesDict) => {
    const filter = {}
    Object.keys(filterValuesDict).forEach((val) => {
      switch (val) {
        case 'prestation':
          filter.prestation = filterValuesDict[val]
            .map((el) => {
              switch (el) {
                case 'TOUS':
                  return []
                default:
                  return el
              }
            })
            .flat(1)
          break
        case 'dateLivraison':
          filter.dateLivraison = filterValuesDict[val]
          break
        case 'statusDrivers':
          filter.statusDrivers = filterValuesDict[val]
          break
        default:
          break
      }
    })
    return filter
  }
  const filterStateChanged = (filterName, selectedFields) => {
    const filterValuesDict = {}

    Object.assign(filterValuesDict, { [filterName]: selectedFields })

    const filter = onChangeFilter(filterValuesDict)

    setFilters({ ...filtersValues, ...filter })
  }
  return (
    <div style={{ flexGrow: 1 }}>
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        {filterArray.map(
          (item, index) =>
            item && (
              <StyledGrid item key={index}>
                <Cell
                  index={index + 1}
                  filterArray={filterArray}
                  filterStateChanged={filterStateChanged}
                  filtersValues={filtersValues}
                />
              </StyledGrid>
            )
        )}
      </Grid>
    </div>
  )
}
FilterGrid.propTypes = {
  statusDriversFilter: PropTypes.bool,
  dateLivraisonFilter: PropTypes.bool,
  prestationFilter: PropTypes.bool,
  setFilters: PropTypes.func,
  filtersValues: PropTypes.object,
}
